<script>
import axios from "axios";
import { PysicalInspectionPath } from "@/path.js";

export default {
  props: ["res_id", "date_of_inspection", "type"],
  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      data: [],
      currentPage: 1,
      fields: ["name", "qty", "units"],
      filter: [],
    };
  },
  mounted() {
    this.getItems();
  },
  methods: {
    async getItems() {
      try {
        let res = await axios.get(
          this.baseUrl + PysicalInspectionPath.GET_INSPECTION_ITEM_DATA,
          {
            params: {
              type: this.type,
              date_of_inspection: this.date_of_inspection,
              res_id: this.res_id,
            },
          }
        );
        if (res.data.status) {
          this.data = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="table-responsive mb-0">
      <b-table
        :key="data.key"
        :items="data"
        :fields="fields"
        responsive="sm"
        :filter="filter"
        :per-page="10"
        :current-page="currentPage"
      >
        <template v-slot:cell(name)="row">
          {{
            type == "gravies" ? row.item.gravy?.name : row.item.packaging?.name
          }}
        </template>
        <template v-slot:cell(qty)="row">
          {{ row.item?.stock_in_hand }}
        </template>
        <template v-slot:cell(units)="row">
          {{
            type == "gravies"
              ? row.item.gravy?.units == "pcs"
                ? "Packets"
                : "Kgs"
              : ""
          }}
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              :key="data.key"
              v-model="currentPage"
              :total-rows="data.length"
              :per-page="10"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>
